# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedInfo extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedInfoModule'
#
#   @selector: ".featured_info_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedInfo.register()
